import { BasePropertyApi } from './base-api.interface';
import { getFontFamily } from './get-common-properties';
import { updateFontFamily } from './update-common-properties';

export const fontFamilyAPI: BasePropertyApi = {
  get: getFontFamily,
  update: updateFontFamily,
};
